import React from "react";

const NotFoundPage = () => <div className="container">NotFound</div>;

export { NotFoundPage };
